import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'ricerca-polizze',
  templateUrl: './ricerca-polizze.component.html',
  styleUrls: ['./ricerca-polizze.component.scss']
})
export class RicercaPolizzeComponent implements OnInit {

  @Input() search: any;
  @Output() searchChange = new EventEmitter();

  constructor(
    private fb: FormBuilder,

  ) { }

  form: FormGroup;

  ngOnInit(): void {
    this.form = this.fb.group({
      numero: [this.search?.nome],
      compagnia: [this.search?.compagnia],
      ramo: [this.search?.ramo],
      agenzia: [this.search?.agenzia],
      contraente: [this.search?.contraente],
    });

    this.form.valueChanges.subscribe(() => this.searchChange.emit(this.form.value));

  }

}
